"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrderTabType;
(function (OrderTabType) {
    OrderTabType[OrderTabType["Open"] = 0] = "Open";
    OrderTabType[OrderTabType["Sent"] = 1] = "Sent";
    OrderTabType[OrderTabType["Delivered"] = 2] = "Delivered";
    OrderTabType[OrderTabType["All"] = 3] = "All";
})(OrderTabType = exports.OrderTabType || (exports.OrderTabType = {}));
